import { mkEntityIdCodec } from '@code-expert/mongo-ts/identity';
import type { eq } from '@code-expert/prelude';
import { date, iots, ord, pipe, string, struct } from '@code-expert/prelude';
import { TaskId } from '/imports/domain';
import { QuestionId } from './Question';
import { QuizSettingsC } from './QuizSettings';

//--------------------------------------------------------------------------------------------------

export const QuizIdBrand = Symbol('QuizId');
export const QuizId = mkEntityIdCodec(QuizIdBrand);
export type QuizId = iots.TypeOf<typeof QuizId>;
export const quizIdEq: eq.Eq<QuizId> = string.Eq;

//--------------------------------------------------------------------------------------------------

export const Quiz = iots.strict({
  _id: QuizId,
  taskId: TaskId,
  createdAt: iots.date,
  updatedAt: iots.date,
  description: iots.string,
  questionIds: iots.array(QuestionId),
  settings: QuizSettingsC,
});

export type Quiz = iots.TypeOf<typeof Quiz>;

export const ordQuizByDate: ord.Ord<Quiz> = pipe(date.Ord, ord.contramap(struct.get('createdAt')));

//--------------------------------------------------------------------------------------------------
